import * as angular from 'angular';

function onlyNum(): ng.IDirective {
    return {
        require: 'ngModel',
        restrict: 'A',
        link(scope: ng.IScope, element: JQLite, attr: ng.IAttributes, ctrl: ng.IController) {
            if (!ctrl) { return; }
            function inputValue(val: any) {
                if (val) {
                    const isMaxChar = attr.maxchar ? parseInt(attr.maxchar, 10) : NaN;
                    const isMinNum = attr.minValue ? parseInt(attr.minValue, 10) : NaN;
                    const isMaxNum = attr.maxValue ? parseInt(attr.maxValue, 10) : NaN;
                    const digitsGroup = attr.group ? parseInt(attr.group, 10) : NaN;
                    const separator = attr.separator ? attr.separator : ' ';
                    // is input type number or string
                    const isNumber = attr.isNumber ? (attr.isNumber === 'true') : false;
                    let digits = val.toString().replace(/[^0-9]/g, '');
                    if (isMaxChar) {
                        digits = digits.substr(0, isMaxChar);
                    }
                    if (isMinNum && isMinNum > parseInt(digits, 10)) {
                        digits = isMinNum.toString();
                    }

                    if (isMaxNum && isMaxNum < parseInt(digits, 10)) {
                        digits = isMaxNum.toString();
                    }

                    if (digitsGroup && digits.length > digitsGroup) {
                        const groups = digits.match(new RegExp('.{1,' + digitsGroup + '}', 'g'));
                        digits = groups.reduce((prev, curr) => prev + separator + curr);
                    }

                    if (digits !== val) {
                        const el = element[0] as HTMLInputElement;
                        let start = el.selectionStart;
                        let end = el.selectionEnd;
                        if (digitsGroup && start >= digitsGroup) {
                            const diff =  digits.length - val.length;
                            start = start + diff;
                            end = end + diff;
                        }
                        ctrl.$setViewValue(digits);
                        ctrl.$render();
                        const prevType = el.type;
                        el.type = 'text';
                        el.setSelectionRange(start, end);
                        el.type = prevType;
                    }
                    return isNumber ? parseInt(digits, 10) : digits;
                }
                const noParseError = !!attr.noParseError;
                if (noParseError && !val) {
                    return '';
                }
                return undefined;
            }
            ctrl.$parsers.push(inputValue);
        }
    };
}

angular
    .module('app.common')
    .directive('onlyNum', onlyNum);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.common/modules/common/directives/only-num.directive.ts